import jsPDF from "jspdf";
import "@/fonts/IPA-Gothic-normal";

export function printA3LandscapePDF(el: HTMLElement, filename?: string) {
  // elの大きさは1ページあたり (w, h) = (1441, 1019) に調整する。

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "px",
    format: "a3"
  });
  doc.html(el, {
    width: 892,
    windowWidth: el.clientWidth,
    callback: doc => {
      doc.save(filename);
    }
  });
}
